<template xmlns="http://www.w3.org/1999/html">
    <div class="animated fadeIn" id="jira-worklogs">
        <div class="form-group row">
            <!--<h2>Create new user rate</h2>-->
            <label class="col-md-3 form-control-label">User</label>
            <div class="col-md-9">
                <select class="form-control" :disabled="employeeId" v-model="employeeId ? employeeId : userId" @change="recalculateMinDateAndClearInput">
                    <option disabled value="">Select user</option>
                    <option v-for="user in activeUsers" v-bind:value="user.id">{{user.displayName}} ({{lastRate(user.id).toFixed(2)}}€/h since {{lastRateDate(user.id)}})</option>
                </select>
            </div>
        </div>
                <!--<br>-->
        <div class="form-group row">
            <label class="col-md-3 form-control-label">Starts at</label>
            <div class="col-md-9">
                <datepicker placeholder="yyyy-mm-dd" input-class="user-rates-date-picker" v-model="startsAt" format="yyyy-MM-dd"></datepicker>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-md-3 form-control-label">Inernal Rate</label>
            <div class="col-md-9">
                <input class="form-control" type="number" min="0" step="0.01" v-model="internalRate"/>
            </div>
        </div>
        <div class="form-group row float-right">
            <div class="col-md-3">
                <button class="btn btn-primary" @click="submitNewRate" :disabled="!userId && !employeeId">Save rate</button>
            </div>
        </div>
    </div>
</template>

<script>

import { mapGetters, mapActions, mapState } from 'vuex';
import VueNotifications from 'vue-notifications';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';

export default {
  name: 'UserRateForm',
  props: ['employeeId'],
  components: {
    // UserCell
    Datepicker
            
  },
  data: function () {
    return {
      userId: '',
      internalRate: '',
      startsAt: '',
      minimumDate: '',
    };
  },
  computed: {
    users() {
      return this.$store.state.JiraUsers.users;
    },
    ...mapGetters('JiraUsers', ['activeUsers']),
    ...mapGetters('UserRates', ['userRateNotification'])
  },
  watch: {
    userRateNotification: {
      handler: function (val) {
        if (this.userRateNotification.status == 'success') {
          this.showSuccessMsg({ title: 'User rate save status', message: this.userRateNotification.message });
        }
        if (this.userRateNotification.status == 'error') {
          for (const i in this.userRateNotification.message) {
            this.showErrorMsg({
              title: 'User rate save status',
              message: this.userRateNotification.message[i]
            });
          }
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({
      createRate: 'UserRates/NEW_USER_RATE' // map `this.add()` to `this.$store.dispatch('increment')`
    }),
    submitNewRate() {
      if (this.employeeId) {
        this.userId = this.employeeId;
      }
      this.createRate({ userId: this.userId, startsAt: moment(this.startsAt).format('YYYY-MM-DD'), internalRate: this.internalRate });
      this.internalRate = '';
    },
    recalculateMinDateAndClearInput() {
      this.internalRate = '';
      this.startsAt = '';
      const ratesByUser = this.$store.getters['UserRates/ratesByUser'][this.userId];
      if (!ratesByUser
                   || !ratesByUser.length) this.minimumDate = '';
      else {
        let maxDate = ratesByUser[0].starts_at;
        ratesByUser.forEach((log) => {
          if (new Date(log.starts_at) > new Date(maxDate)) {
            maxDate = log.starts_at;
          }
        });
        this.minimumDate = maxDate;
      }
    },
    currentRate(userId) {
      return this.$store.getters['UserRates/ratesOnDate'](new Date(), userId);
    },
    lastRateDate(userId) {
      const ratesByUser = this.$store.getters['UserRates/ratesByUser'][userId];
      if (!ratesByUser
                   || !ratesByUser.length) return 'never';
                
      return ratesByUser[ratesByUser.length - 1].starts_at;
    },
    lastRate(userId) {
      const ratesByUser = this.$store.getters['UserRates/ratesByUser'][userId];
      if (!ratesByUser
                   || !ratesByUser.length) return 0;
                
      return ratesByUser[ratesByUser.length - 1].internal_rate / 100.0;
    }
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success
    },
    showInfoMsg: {
      type: VueNotifications.types.info
    },
    showWarnMsg: {
      type: VueNotifications.types.warn
    },
    showErrorMsg: {
      type: VueNotifications.types.error
    }
  },
  mounted() {

  },
};

</script>

<style scoped>
    
</style>
<style>
    .user-rates-date-picker {
        width: 100%;
        border: 1px solid rgba(0, 0, 0, 0.15);
        color: #607d8b;
        padding: 0.5rem 0.75rem;
    }
</style>
